var map = {
	"./de-de/countries.json": [
		714,
		9
	],
	"./es-es/countries.json": [
		715,
		8
	],
	"./fr-ca/countries.json": [
		716,
		7
	],
	"./fr-fr/countries.json": [
		717,
		6
	],
	"./it-it/countries.json": [
		718,
		5
	],
	"./nb-no/countries.json": [
		719,
		4
	],
	"./nl-nl/countries.json": [
		720,
		3
	],
	"./sv-se/countries.json": [
		721,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1723;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./locale lazy ^\.\/.*\/countries\.json$
// module id = 1723
// module chunks = 71